var map = {
	"./2007-08_the-new-york-times.png": "0574",
	"./2008-08_the-new-york-times-magazine.png": "0215",
	"./2009-07_the-daily-beast.png": "d287",
	"./2009-11_der-spiegel.png": "d9ca",
	"./2010-07_bloomberg.png": "0d22",
	"./2011-11_bloomberg.png": "c039",
	"./2012-07_bloomberg.png": "f210",
	"./2012-09_bloomberg.png": "a00d",
	"./2012-10_bloomberg.png": "f899",
	"./2013-03_bloomberg.png": "aa4b",
	"./2013-08_bloomberg.png": "f7c2",
	"./2013-12_bloomberg_a.png": "e4a7",
	"./2014-01_bloomberg.png": "47a5",
	"./2014-01_bloomberg_a.png": "ea1f",
	"./2014-02_bloomberg.png": "a095",
	"./2014-03_bloomberg.png": "11c9",
	"./2014-04_bloomberg.png": "320a",
	"./2014-09_bloomberg.png": "7cb0",
	"./2014-10_bloomberg.png": "f367",
	"./2014-11_bloomberg.png": "6b6a",
	"./2014-11_bloomberg_a.png": "41c8",
	"./2015-02_bloomberg_a.png": "9cbb",
	"./2015-05_bloomberg.png": "face",
	"./2016-07_bloomberg.png": "1992",
	"./2019-09_bloomberg.png": "118c",
	"./2020-02_bloomberg.png": "4dc4",
	"./2020-12_bloomberg.png": "4315"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25d0";